import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { compose } from 'redux'

import { setPortal } from '../../actions/portal'
import { fetchPortal } from '../portal-remote/portalService'
import { setInfo } from '../../actions/info'
import { withPortalIdByRoute } from './withPortalIdByRoute'
import { withPasscodeUrlHandler } from '../passcode/withPasscodeUrlHandler'

export const connectPortal = connect(
  ({ portal, info }) => ({
    hasPortal: portal._id !== undefined,
    hasPasscode: info.passcode !== undefined,
  }),
  { setPortal, setInfo },
)

export const withProtectedPortalRoute = (options) => (Component) => {
  return compose(
    connectPortal,
    withRouter,
    withPortalIdByRoute,
    withPasscodeUrlHandler,
  )(
    class WithPortalWrapperComponent extends React.Component {
      componentDidMount() {
        if (!this.props.hasPasscode) this.props.redirectToSigninPage()

        if (this.shouldFetchPortal(this.props))
          this.fetchPortal(this.props.portalId)
      }

      componentWillReceiveProps(nextProps) {
        if (this.shouldFetchPortal(nextProps))
          this.fetchPortal(nextProps.portalId)
      }

      shouldFetchPortal = props => props.portalId && !props.hasPortal

      fetchPortal = async portalId => {
        try {
          const portal = await fetchPortal(portalId)
          this.props.setPortal(portal)
        } catch (e) {
          if (options.onFetchPortalError) {
            options.onFetchPortalError(e.message)
          }
          this.props.redirectToSigninPage()
        }
      }

      render() {
        if (this.props.hasPortal) return <Component {...this.props} />
        return <div>Loading</div>
      }
    },
  )
}



// WEBPACK FOOTER //
// ./src/modules/portal/withProtectedPortalRoute.js